export default __webpack_public_path__ + "static/media/a012-market-8.09381892.svg";